/**
 * Kleine Strichsymbole als Inline-SVG.
 *
 * Bewusst selbst gezeichnet statt als Zeichensatz oder Emoji: so sehen sie
 * auf jedem Gerät gleich aus, nehmen die Textfarbe an und bleiben in jeder
 * Auflösung scharf. Und sie kosten keine einzige zusätzliche Datei.
 */

const PATHS: Record<string, string[]> = {
  /** Umbenennen */
  pencil: ['M4 20h4L20 8a2.83 2.83 0 0 0-4-4L4 16v4z', 'M14.5 5.5l4 4'],
  /** Einband wechseln */
  droplet: ['M12 3.5s5.5 5.8 5.5 9.3a5.5 5.5 0 0 1-11 0C6.5 9.3 12 3.5 12 3.5z'],
  /** Löschen */
  trash: ['M5 7h14', 'M10 7V4.8h4V7', 'M6.8 7l1 12.2h8.4L17.2 7', 'M10.5 10.5v6', 'M13.5 10.5v6'],
  /** Neu */
  plus: ['M12 5.5v13', 'M5.5 12h13'],
  /** Öffnen */
  open: ['M5 12h12.5', 'M12.5 6.5l5.5 5.5-5.5 5.5'],
  /** Anpassen: drei Schieberegler */
  sliders: [
    'M5 8h8', 'M17 8h2', 'M5 16h2', 'M11 16h8',
    'M15 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0', 'M5 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0',
  ],
  /** Helles Design */
  sun: [
    'M12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6',
    'M12 2.6v2', 'M12 19.4v2', 'M4.3 4.3l1.4 1.4', 'M18.3 18.3l1.4 1.4',
    'M2.6 12h2', 'M19.4 12h2', 'M4.3 19.7l1.4-1.4', 'M18.3 5.7l1.4-1.4',
  ],
  /** Dunkles Design */
  moon: ['M20 14.2A8.2 8.2 0 0 1 9.8 4a8.4 8.4 0 1 0 10.2 10.2z'],
  /** Auto-Scroll starten – gefuelltes Dreieck, deshalb unten FILLED. */
  play: ['M9 6.4l9 5.6-9 5.6z'],
  /** Auto-Scroll pausieren */
  pause: ['M9.5 6.5v11', 'M14.5 6.5v11'],
  /** Teleprompter: Mikrofon */
  mic: ['M12 3.5a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0v-5a3 3 0 0 0-3-3', 'M6 11.5a6 6 0 0 0 12 0', 'M12 17.5v3', 'M9 20.5h6'],
  /** Liste: drei Zeilen mit Punkten */
  list: ['M8 7h11', 'M8 12h11', 'M8 17h11', 'M5 7h.01', 'M5 12h.01', 'M5 17h.01'],
  /** Tempo: Schieberegler mit einem Griff */
  speed: ['M4 12h5', 'M13 12h7', 'M9 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0'],
  /** Gesperrt */
  lock: [
    'M6.5 11V8a5.5 5.5 0 0 1 11 0v3',
    'M5.5 11h13v9h-13z',
    'M12 15v3',
  ],
  /** Entsperrt */
  unlock: [
    'M6.5 11V8a5.5 5.5 0 0 1 10.2-2.9',
    'M5.5 11h13v9h-13z',
    'M12 15v3',
  ],
  /** Bild / Artwork */
  image: [
    'M4.5 5.5h15v13h-15z',
    'M4.5 15.5l4.5-4.5 3 3 3.5-3.5 3.5 3.5',
    'M9 9.5a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8',
  ],
  /** Entfernen / Schliessen */
  x: ['M6 6l12 12', 'M18 6l-12 12'],
  /** Mehr: drei Punkte */
  dots: ['M6 12h.01', 'M12 12h.01', 'M18 12h.01'],
  /** Navigation: Songs – eine Achtelnote */
  note: ['M10 17.5V5l8-1.5v3L10 8', 'M10 17.5a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0'],
  /** Navigation: Band-Bibel – ein aufgeschlagenes Buch */
  book: [
    'M12 6.5C10.2 5.2 7.6 4.8 4.5 5v13c3.1-.2 5.7.2 7.5 1.5 1.8-1.3 4.4-1.7 7.5-1.5V5c-3.1-.2-5.7.2-7.5 1.5z',
    'M12 6.5v13',
  ],
  /** Navigation: Einstellungen – Zahnrad */
  gear: [
    'M12 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6',
    'M19.4 13.5l1.5 1.2-1.8 3.1-1.8-.6a7 7 0 0 1-1.9 1.1L15 20.2h-3.6l-.4-1.9a7 7 0 0 1-1.9-1.1l-1.8.6-1.8-3.1 1.5-1.2a7 7 0 0 1 0-2.2L5.5 10.1 7.3 7l1.8.6A7 7 0 0 1 11 6.5l.4-1.9H15l.4 1.9a7 7 0 0 1 1.9 1.1l1.8-.6 1.8 3.1-1.5 1.2a7 7 0 0 1 0 2.2z',
  ],
  /** Navigation: Wartung – Schraubenschluessel */
  wrench: [
    'M14.7 6.3a4 4 0 0 0 5 5l-9.4 9.4a2.1 2.1 0 0 1-3-3l9.4-9.4a4 4 0 0 0-2-2z',
    'M14.7 6.3a4 4 0 0 1 3.9-1.8l-2.4 2.4.5 2.4 2.4.5 2.4-2.4a4 4 0 0 1-1.8 3.9',
  ],
  /** Seitenleiste auf- und zuklappen */
  panel: ['M4.5 5.5h15v13h-15z', 'M9.5 5.5v13'],
  /** Zurueck */
  back: ['M14.5 6l-6 6 6 6'],
  /** Einstellungen: Konto – eine Person */
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8', 'M4.5 20a7.5 7.5 0 0 1 15 0'],
  /** Einstellungen: Daten und Backup – ein Archivkasten */
  archive: ['M4 5h16v4H4z', 'M5.5 9v10h13V9', 'M10 13h4'],
  /** Einstellungen: Hilfe und Info */
  info: ['M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17', 'M12 11v5.5', 'M12 7.8h.01'],
  /** Einstellungen: Rechtliches – ein Schild */
  shield: ['M12 3.5l7 2.8v5.2c0 4.3-3 7.7-7 9-4-1.3-7-4.7-7-9V6.3z', 'M9 12l2 2 4-4'],
  /** Cloud: Ordner */
  folder: ['M3.5 7.5a2 2 0 0 1 2-2h3.6l2 2h7.4a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z'],
  /** Cloud: Datei */
  file: ['M7 3.5h6.5l4.5 4.5v11a1.5 1.5 0 0 1-1.5 1.5h-9.5A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5z', 'M13.5 3.5V8H18'],
  /** Cloud: Dokument von Schnittstelle Rot */
  doc: ['M7 3.5h6.5l4.5 4.5v11a1.5 1.5 0 0 1-1.5 1.5h-9.5A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5z', 'M9 12h6', 'M9 15.5h6', 'M9 8.5h2.5'],
  /** Cloud: Bild */
  photo: ['M4.5 5.5h15v13h-15z', 'M4.5 15.5l4-4 3.5 3.5 2.5-2.5 5 5', 'M14.5 9.5h.01'],
  /** Cloud: Video */
  video: ['M4 6.5h11v11H4z', 'M15 10.5l5-3v9l-5-3'],
  /** Hochladen */
  upload: ['M12 15.5V4.5', 'M7.5 9L12 4.5 16.5 9', 'M5 15.5v3h14v-3'],
  /** Herunterladen */
  download: ['M12 4.5v11', 'M7.5 11L12 15.5 16.5 11', 'M5 15.5v3h14v-3'],
  /** Suchen */
  search: ['M10.5 4.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12', 'M15 15l4.5 4.5'],
  /** Favorit */
  star: ['M12 4l2.4 5 5.4.6-4 3.7 1.1 5.4L12 16l-4.9 2.7 1.1-5.4-4-3.7 5.4-.6z'],
  /** Zuletzt */
  clock: ['M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16', 'M12 8v4l2.5 2'],
  /** Cloud-Speicher */
  /** Orbit: gemeinsame Cloud – ein Kern, eine Umlaufbahn */
  orbit: ['M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4', 'M3.5 12c0-2.2 3.8-4 8.5-4s8.5 1.8 8.5 4-3.8 4-8.5 4-8.5-1.8-8.5-4', 'M19 7.2a1.2 1.2 0 1 0 0-.01'],
  /** Vollbild */
  expand: ['M4 9V4h5', 'M20 9V4h-5', 'M4 15v5h5', 'M20 15v5h-5'],
  cloud: ['M7.5 18.5a4 4 0 0 1-.4-8A5.5 5.5 0 0 1 17.8 9a4.8 4.8 0 0 1-.3 9.5z'],
  /** Uebersicht */
  home: ['M4.5 11L12 4.5l7.5 6.5', 'M6.5 9.5v9h11v-9'],
  /** Rasteransicht */
  grid: ['M4.5 4.5h6v6h-6z', 'M13.5 4.5h6v6h-6z', 'M4.5 13.5h6v6h-6z', 'M13.5 13.5h6v6h-6z'],
  /** Listenansicht */
  rows: ['M4.5 6h15', 'M4.5 12h15', 'M4.5 18h15'],
  /** Dieses Geraet */
  device: ['M6.5 3.5h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z', 'M11 17.5h2'],
  /** Erledigt */
  check: ['M5 12.5l4.5 4.5L19 7.5'],
  /** Abmelden */
  logout: ['M14 5.5h4.5v13H14', 'M10 8.5L6.5 12l3.5 3.5', 'M6.5 12h9'],
  /** Build: Code */
  code: ['M8.5 8l-4 4 4 4', 'M15.5 8l4 4-4 4', 'M13.5 5.5l-3 13'],
  /** Terminal */
  terminal: ['M4.5 5.5h15v13h-15z', 'M7.5 10l2.5 2-2.5 2', 'M12 14.5h4'],
  /** Idee, Vorschlag */
  spark: ['M12 3.5l1.6 5.2 5.4 1.6-5.4 1.6L12 17.1l-1.6-5.2L5 10.3l5.4-1.6z', 'M18.5 16l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z'],
  /** Tonaufnahme */
  music: ['M9 18V5.5l10-2v12.5', 'M9 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0', 'M19 16a3 3 0 1 1-6 0 3 3 0 0 1 6 0'],
};

/** Symbole, die gefuellt statt gestrichelt gezeichnet werden. */
const FILLED = new Set(['play']);

/** Liefert ein SVG-Symbol, das die Textfarbe seines Elternteils annimmt. */
export function icon(name: keyof typeof PATHS | string): SVGSVGElement {
  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '22');
  svg.setAttribute('height', '22');
  const filled = FILLED.has(String(name));
  svg.setAttribute('fill', filled ? 'currentColor' : 'none');
  svg.setAttribute('stroke', filled ? 'none' : 'currentColor');
  svg.setAttribute('stroke-width', '1.7');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');

  for (const d of PATHS[name] ?? []) {
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', d);
    svg.append(path);
  }
  return svg;
}
